import { Http } from '@angular/http';
import { RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { Locale } from './locale.service';
import { ServerMapping } from './serverMapping.service';
import { Status } from './status.service';
import { Observable } from 'rxjs/Observable';
import { GrowlManager } from './../manager/growl.manager';


export class SupplierData {
    supplierCode: string;
    supplierName: string;
    constructor(code: string, label: string) {
        this.supplierCode = code;
        this.supplierName = label;
    }
}

@Injectable()
export class SupplierService {

    private supplierData;

    constructor(private serverMapping: ServerMapping,
                private http: Http,
                private locale: Locale,
                private growlManager: GrowlManager,
                private status: Status) {

        this.clearData();
    }

    clearData() {
        this.supplierData = new SupplierData("", "");
    }

    getSupplierData(){
        return this.supplierData;
    }

   loadSupplierData(purchase_organization, company_code, supplier_code, language): Observable<any> {
        // make the request
        return this.http.get(
                    this.serverMapping.supplierURL +
                    '?purchase_organization=' + purchase_organization +
                    '&company_code=' + company_code +
                    '&supplier_code=' + supplier_code +
                    '&language=' + this.locale.getPreferredLanguage()) .map(
                        res => {
                            // TODO : GROWL MAMAGER HERE
                            const data = res.json();

                            //TODO : GROWL MANAGER
                            if(this.growlManager.checkForErrorInResponse(data)){
                                this.growlManager.showMessagesByResponse(data);
                            }else{}                            

                            return data;
                        },
                        error => {
                            console.log('OPS ' + error);
                        }
                    );
    }

}



// WEBPACK FOOTER //
// ./src/app/service/supplierService.service.ts